//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $screen from '../../../../js/utils/_screen'
export default {
	props: {
		small: Boolean
	},
	created() {
		if (!window.pageListener) {
			window.pageListener = (e) => {
				if (e.key == 'ArrowLeft' && this.enablePrev) {
					// left
					this.moveIndex(-1);
				}

				else if (e.key == 'ArrowRight' && this.enableNext) {
					//right
					this.moveIndex(1);
				}
			}
			window.addEventListener("keydown", window.pageListener);
		}
	},
	methods: {
		selectIndex: function (index) {
			this.$emit("submitPage", index);
		},
		moveIndex: function (increment) {
			let newIndex = this.query.currentPage + increment;
			this.selectIndex(newIndex);
		},
    screenSize: function(){
      if ($screen.md.matches) {
        return true;
      }
      else{
        return false;
      }

    },
		resetIndex: function () {
			this.selectIndex(0);
		},
		checkPaginationVisibility(i) {
			let cp = this.currentPage;
			let tp = this.results.totalPages;

			if (tp <= 9) return true;
			if (i === 0) return true
			if (i === tp - 1) return true

			if (cp < 4) {
				if (i < 4) return true;
			}

			if (Math.abs(cp - i) <= 2) return true

			if (cp > tp - 5) {
				if (i > tp - 5) return true;
			}

			return false;
		},
	},
	computed: {
		navClass: function() {
			if (this.small) {
					return "pagination pagination--rightAlign pagination--small";
			}
			else {
					return "pagination"
			}
		},
		currentPage() {
			return this.query.currentPage;
		},
		settings: function () {
			return this.$store.state.settings;
		},
		enablePrev: function () {
			return this.query.currentPage > 0;
		},
		enableNext: function () {
			return this.query.currentPage + 1 < this.results.totalPages;
		},
		results: function () {
			return this.$store.state.results;
		},
		query: function () {
			return this.$store.state.searchQuery;
		},
	},
  mounted(){
    let  paginationSmall = document.querySelector('.pagination:not(.pagination--small)');
    if(!this.screenSize() && paginationSmall !== null){
      paginationSmall.classList.add('pagination--small');
    }
  }
};
